<app-title-bar rootBreadCrumbs="['i18n.core.navigation.parking']" titleText="i18n.domain.zone-damage.title"></app-title-bar>
<div class="d-lg-flex align-items-center mb-2">
  <app-client-autocomplete [(selectedClient)]="selectedClient" class="client-autocomplete me-2"></app-client-autocomplete>
  <div class="form-inline"
       *ngIf="selectedClient">
    <ejs-dropdownlist [placeholder]="'i18n.domain.zone-damage.notifications.all' | translate"
                      [dataSource]="notificationList$ | async"
                      [fields]="dropdownSettings"
                      (valueChange)="applyFilters($event)"
                      [showClearButton]="true"></ejs-dropdownlist>
  </div>
</div>
<ng-container *ngIf="selectedClient">
  <ejs-grid #grid
            class="grid-with-footer"
            width="100%"
            rowHeight="38"
            [dataSource]="data"
            [allowSorting]="true"
            [filterSettings]="filterSettings"
            [allowFiltering]="true"
            [allowPaging]="true"
            [pageSettings]="pageSettings"
            [editSettings]="editSettings"
            [searchSettings]="searchOptions"
            (actionComplete)="actionComplete($event)"
            (actionBegin)="actionBegin($event)">
    <e-columns>
      <e-column field="id"
                [visible]="false"
                [isPrimaryKey]="true"></e-column>
      <e-column field="reportTime"
                headerText="{{'i18n.domain.zone-damage.fields.reportTime' | translate}}"
                width="160px"
                type="date"
                [filter]="dateFilter"
                clipMode="EllipsisWithTooltip">
        <ng-template #template
                     let-data>
          {{data.reportTime | date:'dd.MM.yyyy HH:mm:ss'}}
        </ng-template>
      </e-column>
      <e-column field="zone.name"
                [allowFiltering]="false"
                [allowSorting]="false"
                headerText="{{'i18n.domain.zone-damage.fields.zone' | translate}}"
                clipMode="EllipsisWithTooltip">
      </e-column>
      <e-column field="reportPositionLatitude"
                [allowFiltering]="false"
                [allowSorting]="false"
                headerText="{{'i18n.domain.zone-damage.fields.position' | translate}}"
                clipMode="EllipsisWithTooltip">
        <ng-template #template
                     let-data>
          {{data.reportPositionLatitude}}/{{data.reportPositionLongitude}}
        </ng-template>
      </e-column>
      <e-column field="device.name"
                [allowFiltering]="false"
                [allowSorting]="false"
                headerText="{{'i18n.domain.zone-damage.fields.device' | translate}}"
                clipMode="EllipsisWithTooltip">
      </e-column>
      <e-column field="damageDescription"
                [allowFiltering]="false"
                [allowSorting]="false"
                headerText="{{'i18n.domain.zone-damage.fields.damageDescription' | translate}}"
                clipMode="EllipsisWithTooltip"></e-column>
      <e-column field="state"
                headerText="{{'i18n.domain.zone-damage.fields.state' | translate}}"
                width="120px"
                [allowFiltering]="false"
                [allowSorting]="false"
                clipMode="EllipsisWithTooltip">
        <ng-template #template
                     let-data>
          <span class="e-icons"
                [class.icon-checkmark]="data.state === ZoneDamageState.Repaired"></span>
        </ng-template>
      </e-column>

      <e-column headerText=""
                [commands]="gridCommands"
                width="60px"></e-column>
    </e-columns>
    <ng-template #editSettingsTemplate
                 let-data>
      <app-zone-damage-edit-form [zoneDamageEditForm]="gridEditForm"
                                 [client]="selectedClient"
                                 [damage]="data"></app-zone-damage-edit-form>
    </ng-template>
  </ejs-grid>
</ng-container>
